import { RestError } from "../../services/rest-service/RestService";
import { useQuery, useQueryClient } from "react-query";
import OfflineDataService  from "../../services/offline-data-service/OfflineDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { INavigationItem } from "../../services/navigation-data-service/Models";

export type UseOfflineGroupsQueryParameters = {
    customerID: number
} & BaseUseQueryParameters<INavigationItem[]>

export function useOfflineGroups(params: UseOfflineGroupsQueryParameters) {
    const queryClient = useQueryClient();
    
    return useQuery<INavigationItem[] | undefined, RestError>(
        keys.data(params.customerID),
        ({ signal }) => {
            if (params.customerID) {
                return OfflineDataService.getOfflineGroups(params.customerID, signal);
            }

        },
        {
            // limit refresh to occur every hour, the data will be refreshed when logging in and also 
            // at offline/online transistions
            //staleTime: (60 * 60) * 1000,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            onSettled: () => {
                // anytime the offline data is fetched, invalidate the offline configuration data since it is
                // constructed from the offline data call
                queryClient.invalidateQueries(keys.configuration());
            }
        }
    );
}
